import {
  DISCLAIMER_CANCELLATION_DICTIONARY,
  FILTERS_KEYS_DICTIONARY,
  PROVIDER,
  QUOTE_SEARCH_FILTER_DEFAULT_ROWS,
  QUOTE_STATUSES_PROVIDER
} from '../../config/settings/constants'
import { makeActionCreator } from '../../config/store/utils'

import { checkStatusProviderValue } from '../../modules/utils/checkers'

import { getQuoteSearch, getSellerNotification } from '../../services/quoteSearch'
import { getSupplierSkillCaculation, getSupplierHability, getPrioritizedSupplier } from '../../services/supplier'

export const GET_QUOTE_SEARCH_ERROR = 'GET_QUOTE_SEARCH_ERROR'
export const GET_QUOTE_SEARCH_SUCCESS = 'GET_QUOTE_SEARCH_SUCCESS'
export const GET_QUOTE_SEARCH = 'GET_QUOTE_SEARCH'
export const onGetQuoteSearch = makeActionCreator(GET_QUOTE_SEARCH)
export const onGetQuoteSearchError = makeActionCreator(GET_QUOTE_SEARCH_ERROR, 'payload')
export const onGetQuoteSearchSuccess = makeActionCreator(GET_QUOTE_SEARCH_SUCCESS, 'payload')
export const onGetQuoteSearchThunk = payload => async dispatch => {
  dispatch(onGetQuoteSearch())

  try {
    const filters = Object.fromEntries(payload.query.entries())
    const translatedFilters = Object.keys(filters)
      .filter(key => !(key === 'status' && filters[key] === 'all'))
      .reduce((dictionary, key) => ({ ...dictionary, [FILTERS_KEYS_DICTIONARY[key] || key]: filters[key] }), {})
    const queryString = new URLSearchParams({
      ...translatedFilters,
      [FILTERS_KEYS_DICTIONARY.rows]: QUOTE_SEARCH_FILTER_DEFAULT_ROWS
    })

    const { data } = await getQuoteSearch({ actionType: GET_QUOTE_SEARCH, queryString })

    return dispatch(
      onGetQuoteSearchSuccess({
        page: data.payload?.page,
        pageCount: data.payload?.pageCount,
        pageSize: data.payload?.pageSize,
        resultCount: data.payload?.resultCount,
        prioritized: data.payload?.priorizado,
        results: data.payload?.resultados.map(quote => ({
          call: quote.estadoConvocatoria.includes('Segundo'),
          closeDate: quote.fechaCierre,
          creationDate: quote.fechaApertura,
          externalCode: quote.codigo,
          myBids: quote.misOfertas,
          name: quote.nombre,
          organization: quote.organismo,
          publishDate: quote.fechaPublicacion,
          status: quote.estado,
          unit: quote.unidad,
          purchaseOrderPending: quote.accionOcPendiente
        }))
      })
    )
  } catch (error) {
    if (error?.originalError && error?.originalError?.name === 'CanceledError') {
      return
    }

    return dispatch(
      onGetQuoteSearchError({
        error: {
          code: error.code,
          message: error.message
        }
      })
    )
  }
}

export const GET_SELLER_NOTIFICATION = 'GET_SELLER_NOTIFICATION'
export const GET_SELLER_NOTIFICATION_ERROR = 'GET_SELLER_NOTIFICATION_ERROR'
export const GET_SELLER_NOTIFICATION_SUCCESS = 'GET_SELLER_NOTIFICATION_SUCCESS'
export const onGetSellerNotification = makeActionCreator(GET_SELLER_NOTIFICATION)
export const onGetSellerNotificationError = makeActionCreator(GET_SELLER_NOTIFICATION_ERROR, 'payload')
export const onGetSellerNotificationSuccess = makeActionCreator(GET_SELLER_NOTIFICATION_SUCCESS, 'payload')
export const onGetSellerNotificationThunk = () => async dispatch => {
  dispatch(onGetSellerNotification())
  try {
    const { data } = await getSellerNotification()
    return dispatch(
      onGetSellerNotificationSuccess({
        countRequests: data.payload.countSolicitudes,
        cancellationDays: data.payload.diasCancelacion,
        showDisclaimer: data?.payload?.mostrarMarquesina === DISCLAIMER_CANCELLATION_DICTIONARY.SHOW
      })
    )
  } catch (error) {
    return dispatch(
      onGetSellerNotificationError({
        error: {
          code: error.code,
          message: error.message
        }
      })
    )
  }
}

export const LOADING = 'LOADING'
export const onLoading = makeActionCreator(LOADING)

export const CLOSE_DIALOG_WARNING_HABILITY_PARTICIPATE = 'CLOSE_DIALOG_WARNING_HABILITY_PARTICIPATE'
export const onCloseDialogWarningHabilityParticipate = makeActionCreator(CLOSE_DIALOG_WARNING_HABILITY_PARTICIPATE)

export const OPEN_DIALOG_WARNING_HABILITY_PARTICIPATE = 'OPEN_DIALOG_WARNING_HABILITY_PARTICIPATE'
export const onOpenDialogWarningHabilityParticipate = makeActionCreator(OPEN_DIALOG_WARNING_HABILITY_PARTICIPATE)

export const MSG_ORDER_PRIORIZED = 'MSG_ORDER_PRIORIZED'
export const onMsgOrderPrioritized = makeActionCreator(MSG_ORDER_PRIORIZED)

export const CLEAR_MSG_ORDER_PRIORIZED = 'CLEAR_MSG_ORDER_PRIORIZED'
export const onClearMsgOrderPrioritized = makeActionCreator(CLEAR_MSG_ORDER_PRIORIZED)

export const APPLY_ERROR_SUPPLIER_PRIORITIZED = 'APPLY_ERROR_SUPPLIER_PRIORITIZED'
export const onApplyErrorSupplierPrioritized = makeActionCreator(APPLY_ERROR_SUPPLIER_PRIORITIZED, 'payload')

export const APPLY_PRIORIZED_BUYER = 'APPLY_PRIORIZED_BUYER'
export const onApplyPriorizedBuyer = makeActionCreator(APPLY_PRIORIZED_BUYER)

export const SET_FORCE_PRIORIZED_ALREADY = 'SET_FORCE_PRIORIZED_ALREADY '
export const onForcePriorizedAlready = makeActionCreator(SET_FORCE_PRIORIZED_ALREADY)

export const GET_SUPPLIER_HABILITY_V3 = 'GET_SUPPLIER_HABILITY_V3'
export const GET_SUPPLIER_HABILITY_V3_ERROR = 'GET_SUPPLIER_HABILITY_V3_ERROR'
export const GET_SUPPLIER_HABILITY_V3_SUCCESS = 'GET_SUPPLIER_HABILITY_V3_SUCCESS'

export const onGetSupplierHabilityV3 = makeActionCreator(GET_SUPPLIER_HABILITY_V3)
export const onGetSupplierHabiltyV3Error = makeActionCreator(GET_SUPPLIER_HABILITY_V3_ERROR, 'payload')
export const onGetSupplierHabilityV3Success = makeActionCreator(GET_SUPPLIER_HABILITY_V3_SUCCESS, 'payload')

export const onGetSupplierHabilityV3Thunk = payload => async dispatch => {
  dispatch(onGetSupplierHabilityV3())
  try {
    const { data } = await getSupplierHability({
      orgTaxID: payload.orgTaxID,
      isForeign: payload.isForeign,
      actionType: GET_SUPPLIER_HABILITY_V3
    })

    const supplieHability = {
      businessName: data?.payload?.razonSocial || '',
      isEnabled: data?.payload?.habilidad || false,
      status: checkStatusProviderValue(data?.payload?.habilidad, data?.payload?.acreditacionVigente),
      error: !data?.payload?.habilidad ? [{ code: '400', description: 'compraagil_error_inhabilidad_001' }] : null
    }

    return dispatch(onGetSupplierHabilityV3Success(supplieHability))
  } catch (error) {
    return dispatch(
      onGetSupplierHabiltyV3Error({
        error: {
          code: error.code,
          message: error.message
        }
      })
    )
  }
}

export const GET_PRIORITIZED_SUPPLIER = 'GET_PRIORITIZED_SUPPLIER'
export const GET_PRIORITIZED_SUPPLIER_ERROR = 'GET_PRIORITIZED_SUPPLIER_ERROR'
export const GET_PRIORITIZED_SUPPLIER_SUCCESS = 'GET_PRIORITIZED_SUPPLIER_SUCCESS'
export const onGetPrioritizedSupplier = makeActionCreator(GET_PRIORITIZED_SUPPLIER)
export const onGetPrioritizedSupplierError = makeActionCreator(GET_PRIORITIZED_SUPPLIER_ERROR, 'payload')
export const onGetPrioritizedSupplierSuccess = makeActionCreator(GET_PRIORITIZED_SUPPLIER_SUCCESS, 'payload')

export const onGetPrioritizedSupplierThunk = payload => async (dispatch, getState) => {
  dispatch(onGetPrioritizedSupplier())
  try {
    const { data } = await getPrioritizedSupplier({ orgTaxID: payload.orgTaxID })

    const businesSize = data?.payload?.tamanoEmpresa
    const isNoEMT = businesSize.tamanoEmpresa === PROVIDER.NOT_PRIORIZED

    if (isNoEMT) {
      dispatch(onApplyErrorSupplierPrioritized(businesSize))
    } else {
      dispatch(onGetPrioritizedSupplierSuccess(businesSize))
    }
    /**
     * SEND FOREIGN STATUS TO USED IN HABILITY CALCULATOR
     * IS THE UNIQUE FORM TO GET THE "ISFOREIGN" ATTRIBUTE
     */
    payload?.callback && payload.callback(data?.payload?.esExtranjero)

    return {
      isNoEMT,
      isForced: Boolean(businesSize?.forzado),
      idForced: businesSize?.idMotivoForzado ?? null
    }
  } catch (error) {
    const currentMark = getState().quoteSearchHeadingFilters?.supplierPrioritized
    if (!currentMark) {
      dispatch(onGetPrioritizedSupplierError({ error }))
    }
    return null
  }
}

export const GET_SUPPLIER_HABILITY_V1 = 'GET_SUPPLIER_HABILITY_V1'
export const GET_SUPPLIER_HABILITY_V1_ERROR = 'GET_SUPPLIER_HABILITY_V1_ERROR'
export const GET_SUPPLIER_HABILITY_V1_SUCCESS = 'GET_SUPPLIER_HABILITY_V1_SUCCESS'
export const onGetSupplierHabilityV1 = makeActionCreator(GET_SUPPLIER_HABILITY_V1)
export const onGetSupplierHabilityV1Error = makeActionCreator(GET_SUPPLIER_HABILITY_V1_ERROR, 'payload')
export const onGetSupplierHabilityV1Success = makeActionCreator(GET_SUPPLIER_HABILITY_V1_SUCCESS, 'payload')
export const onGetSupplierHabilityV1Thunk = payload => async dispatch => {
  dispatch(onGetSupplierHabilityV1())
  try {
    const { data } = await getSupplierSkillCaculation({ orgTaxID: payload.orgTaxID })

    const isSupplierHability =
      (data?.payload?.isNational && data?.payload?.skillState === QUOTE_STATUSES_PROVIDER.ENABLED) ||
      (!data?.payload?.isNational && data?.payload?.accreditation)

    const supplieHability = {
      businessName: data?.payload?.businessName || '',
      isEnabled: isSupplierHability,
      status: data?.payload?.skillState || '',
      error: !isSupplierHability ? [{ code: '400', description: 'compraagil_error_inhabilidad_001' }] : null
    }

    return dispatch(onGetSupplierHabilityV1Success(supplieHability))
  } catch (error) {
    return dispatch(
      onGetSupplierHabilityV1Error({
        error: {
          code: error.code,
          message: error.message
        }
      })
    )
  }
}
